import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAryakuavdfpmx5b9aFELH1Tk5pGnZOwws",
  authDomain: "a-ldi-web.firebaseapp.com",
  projectId: "a-ldi-web",
  storageBucket: "a-ldi-web.firebasestorage.app",
  messagingSenderId: "664901590046",
  appId: "1:664901590046:web:841a86c661ff01a4c8e20f"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
